export const OperatingSystemEnum = Object.freeze({
    android: "android",
    ios: "ios",
    windowsPhone: "windowsPhone",
    unknown: "unknown"
})